import { createSlice } from '@reduxjs/toolkit'

export const toolSlice = createSlice({
  name: 'tool',
  initialState: {
    activeTool: "Select",
  },
  reducers: {
    activateTool: (state, action) => {
      state.activeTool = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const { activateTool } = toolSlice.actions;

export default toolSlice.reducer;